import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";
import Utils from "../../../../../utils";
import AuthService from "../../../../../AuthService";
import { useSnackbar } from "notistack";
const TabSizes = ({
  tamanhoItemEdicao,
  erros,
  optionsCurrency,
  produto,
  setState,
  handleClickStopAndPause,
  handleSubmit,
}) => {
  const service = new AuthService();
  const { enqueueSnackbar } = useSnackbar();

  const handleChangeComplementoTamanho = (event, value) => {
    const tempTamanhoItemEdicao = { ...tamanhoItemEdicao };
    tempTamanhoItemEdicao[event.target.name] = value || event.target.value;
    setState((prev) => ({ ...prev, tamanhoItemEdicao: tempTamanhoItemEdicao }));
  };

  const handleAddTamanhoItem = () => {
    let tamanhoItemEdicao = {
      descricao: "",
      valor: 0.0,
      codigoExterno: null,
      ordem: 0,
    };

    setState((prev) => ({ ...prev, tamanhoItemEdicao }));
  };

  const novoComplementoTamanho = () => {
    return {
      id: null,
      descricao: "TAMANHO",
      max: 1,
      min: 0,
      obrigatorio: true,
      ordem: 1,
      tipoComplemento: "TAMANHO",
      complementoItens: [],
    };
  };

  const handleAddTamanho = () => {
    const tempErros = { ...erros };
    const tempProduto = { ...produto };

    let complementoTamanho = tempProduto.complementos.find(function (elem) {
      return elem.tipoComplemento === "TAMANHO";
    });

    if (tamanhoItemEdicao.descricao === "") {
      enqueueSnackbar("Preencha os campos requeridos (Campo: Tamanho) ", {
        variant: "warning",
      });
      tempErros.tamanho = "O tamanho é obrigatório!";
      setState((prev) => ({ ...prev, erros: tempErros }));
      return;
    }

    if (!complementoTamanho) {
      complementoTamanho = novoComplementoTamanho();
    } else {
      let itens = complementoTamanho.complementoItens.filter(function (elem) {
        return elem.id !== tamanhoItemEdicao.id;
      });

      complementoTamanho.complementoItens = itens;
    }
    complementoTamanho.complementoItens.push(tamanhoItemEdicao);
    complementoTamanho.produto = { id: tempProduto.id };

    let service = new AuthService();
    service
      .post("/complemento", complementoTamanho)
      .then((retorno) => {
        enqueueSnackbar("Complemento salvo com sucesso", {
          variant: "success",
        });

        let indexComplemento = tempProduto.complementos.findIndex(
          (el) => el.id === retorno.id
        );

        if (indexComplemento === -1) tempProduto.complementos.push(retorno);

        tempProduto.complementos.forEach((complemento) => {
          if (complemento.id === retorno.id) {
            tempProduto.complementos[indexComplemento] = retorno;
          }
        });
        handleSubmit();
        setState((prev) => ({
          ...prev,
          produto: tempProduto,
          tamanhoItemEdicao: null,
        }));
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar salvar o complemento", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar(
              "Falha ao salvar o complemento " + elem.errorMessage,
              { variant: "error" }
            );
          });
        }
      });
  };

  const handleRemoveTamanhoItem = (complementoItem, complemento) => {
    const tempProduto = { ...produto };
    let temp = [...complemento.complementoItens];
    let pos = temp.findIndex((r) => r === complementoItem);

    if (complementoItem.id != null) {
      service
        .delete(`/complementoItem/${complementoItem.id}`)
        .then((retorno) => {
          temp.splice(pos, 1);
          complemento.complementoItens = temp;
          enqueueSnackbar("Item do complemento excluido com sucesso", {
            variant: "success",
          });
          setState((prev) => ({ ...prev, produto: tempProduto }));
        })
        .catch((err) => {
          enqueueSnackbar("Erro ao tentar excluir item do complemento", {
            variant: "error",
          });
        });
    } else {
      temp.splice(pos, 1);
      complemento.complementoItens = temp;
      enqueueSnackbar("Item do complemento excluido com sucesso", {
        variant: "success",
      });
      handleSubmit();
      setState((prev) => ({ ...prev, produto: tempProduto }));
    }
  };

  const handleEditarTamanho = (tamanhoItem) => {
    setState((prev) => ({ ...prev, tamanhoItemEdicao: tamanhoItem }));
  };

  return (
    <>
      <Box>
        {tamanhoItemEdicao ? (
          <Grid
            container
            spacing={1}
            alignItems="center"
            alignContent="flex-end"
          >
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <TextField
                variant="outlined"
                fullWidth
                required
                label="Tamanho"
                error={erros.tamanho}
                helperText={erros.tamanho}
                name="descricao"
                defaultValue={tamanhoItemEdicao.descricao || ""}
                onChange={(event) => handleChangeComplementoTamanho(event)}
              />
            </Grid>

            <Grid
              size={{
                xs: 6,
                sm: 2
              }}>
              <NumericFormat
                customInput={TextField}
                label="Valor"
                fullWidth
                variant="outlined"
                value={tamanhoItemEdicao.valor}
                thousandSeparator=""
                decimalSeparator=","
                decimalScale={optionsCurrency.decimalPlaces}
                fixedDecimalScale
                prefix={optionsCurrency.currencySymbol}
                name="valor"
                onValueChange={(values) =>
                  handleChangeComplementoTamanho({
                    target: { name: "valor", value: values.value },
                  })
                }
              />
            </Grid>

            <Grid
              size={{
                xs: 6,
                sm: 1
              }}>
              <TextField
                variant="outlined"
                fullWidth
                label="Ordem"
                name="ordem"
                defaultValue={tamanhoItemEdicao.ordem || ""}
                onChange={(event) => handleChangeComplementoTamanho(event)}
              />
            </Grid>

            <Grid
              size={{
                xs: 4,
                sm: 1
              }}>
              <TextField
                variant="outlined"
                fullWidth
                label="Id Ext."
                name="codigoExterno"
                defaultValue={tamanhoItemEdicao.codigoExterno || ""}
                onChange={(event) => handleChangeComplementoTamanho(event)}
              />
            </Grid>

            <Grid
              size={{
                xs: 4,
                sm: 1
              }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleAddTamanho}
              >
                Salvar
              </Button>
            </Grid>

            <Grid
              size={{
                xs: 4,
                sm: 1
              }}>
              <Button
                onClick={(event) => setState({ tamanhoItemEdicao: null })}
              >
                <CancelIcon />
              </Button>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </Box>
      {tamanhoItemEdicao ? null : (
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => handleAddTamanhoItem()}
          >
            Adicionar tamanho
          </Button>
        </Grid>
      )}
      {produto?.complementos?.length > 0 &&
        produto.complementos.map((complementos) =>
          complementos.tipoComplemento === "TAMANHO" ? (
            <React.Fragment key={complementos.id}>
              {complementos.complementoItens.map((complementoItem, index) => (
                <Box key={index}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid
                      size={{
                        xs: 4,
                        sm: 6
                      }}>
                      <Typography>{complementoItem.descricao}</Typography>
                    </Grid>

                    <Grid
                      size={{
                        xs: 4,
                        sm: 2
                      }}>
                      <Typography>
                        {Utils.formatNumber(complementoItem.valor)}
                      </Typography>
                    </Grid>

                    <Grid
                      size={{
                        xs: 1,
                        sm: 2
                      }}>
                      <Button
                        startIcon={
                          complementoItem.pausado ? (
                            <PlayCircleOutlineIcon />
                          ) : (
                            <PauseCircleOutlineIcon />
                          )
                        }
                        color={
                          complementoItem.pausado ? "secondary" : "primary"
                        }
                        onClick={(event) => {
                          handleClickStopAndPause(
                            event,
                            complementoItem,
                            complementos
                          );
                        }}
                      >
                        {complementoItem.pausado ? "Iniciar" : "Pausar"}
                      </Button>
                    </Grid>

                    <Grid
                      size={{
                        xs: 1,
                        sm: 1
                      }}>
                      <Button
                        onClick={(event) =>
                          handleRemoveTamanhoItem(complementoItem, complementos)
                        }
                      >
                        <DeleteIcon />
                      </Button>
                    </Grid>

                    <Grid
                      size={{
                        xs: 2,
                        sm: 1
                      }}>
                      <Button
                        startIcon={<EditIcon />}
                        onClick={(event) =>
                          handleEditarTamanho(complementoItem)
                        }
                      >
                        Editar
                      </Button>
                    </Grid>
                  </Grid>

                  <Divider />
                </Box>
              ))}
            </React.Fragment>
          ) : null
        )}
    </>
  );
};

export default TabSizes;
